import styled from '@emotion/styled'

const IconStyles = styled.i({
  display: 'inline-flex',
  color: 'rgba(var(--theme-text-dark-low))',

  '& svg': {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
  },
})

const Icon = () => (
  <IconStyles>
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="1024"
      height="1024"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinejoin="miter"
        strokeLinecap="round"
        strokeMiterlimit="4"
        strokeWidth="85.312"
        d="M938.688 640v128c0 94.272-76.416 170.688-170.688 170.688h-512c-94.272 0-170.688-76.416-170.688-170.688v-512c0-94.272 76.416-170.688 170.688-170.688h128"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeMiterlimit="4"
        strokeWidth="85.312"
        d="M597.312 85.312h341.376v341.376"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeMiterlimit="4"
        strokeWidth="85.312"
        d="M931.328 92.672l-482.688 482.688"
      />
    </svg>
  </IconStyles>
)

export default Icon
